export default {"src":"/_next/static/media/logo_employer_en.b3019581.svg","height":45,"width":110};